<div class="release-package mb-12">
  <div class="flex justify-start mb-12">
      <button class="mr-16 fs-16 fw-500 h-40" [ngClass]="selectedTab === 0 ? 'selected-tab fs-18 fw-600' : 'unselected-tab'" (click)="tabChange(0)">{{ 'INSTANCE_DETAILS.APPLY_RELEASE_PACKAGE' | transloco }}</button>
      <button class="mr-16 fs-16 fw-500 h-40" [ngClass]="selectedTab === 1 ? 'selected-tab fs-18 fw-600' : 'unselected-tab'" (click)="tabChange(1)">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</button>
  </div>
  <mat-divider class="neutral-2"></mat-divider>
  @if (selectedTab === 0) {
        <app-instance-apply-configuration [instance]="instance" [applyConfigInProgressing]="applyConfigInProgress" [availableConfigurations]="availableConfigurations"
        (applyConfigClick)="applyConfigClick($event)" (refreshClick)="loadReleaseData()" [isVerifying]="isVerifying" [configs]="configurations" [oldView]="false" [configLoaded]="availableConfigLoaded"></app-instance-apply-configuration>
    }
    @else if (selectedTab === 1) {
      <div class="flex flex-row justify-between items-center mb-24 mt-16 w-100-percent">
       <div class="flex flex-row items-center">
        <div class="mat-body-1 fw-700 title m-0 fs-20">
          <span class="mr-8 mat-headline-6 fw-700 fs-20">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
        </div>
        <div class="flex flex-row items-center ml-12">
          <app-search-filter placeholder="SEARCH.SEARCH" (changed)="search($event)" class="search-section"></app-search-filter>
          <span class="vertical-dash ml-12"></span>
          <button [matMenuTriggerFor]="menu" #filterTrigger class="flex justify-between items-center fw-500 white-bg ml-12 filter">
            <mat-icon svgIcon="filter_alt" class="mr-8 mb-2"></mat-icon>
            <span class="">{{ 'INSTANCE_DETAILS.FILTERS' | transloco }}</span>
          </button>
          <mat-menu #menu="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16">
            <span class="mat-subtitle-2 fs-14">{{ 'INSTANCE_DETAILS.FILTER_BY_STATUS' | transloco }}</span>
            <mat-divider class="neutral-2 mt-8 mb-16"></mat-divider>
            <div class="flex flex-col overflow-class pr-10 filter-menu">
              <div *ngFor="let option of filterOptions" class="flex flex-row items-center cursor-pointer w-100-percent p-6"
                (click)="filterOptionChange(option)" >
                <mat-icon *ngIf="selectedFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                <mat-icon *ngIf="selectedFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
                  </mat-icon>
                <span class="mat-body-1 fw-500 ml-6 mr-auto mb-0 primary-fg">
                  {{option.label}}
                </span>
              </div>
            </div>
          </mat-menu>
        </div>
       </div>
       <app-environment-paginator [length]="viewResultData?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)" class="ml-12 env-paginator"></app-environment-paginator>
      </div>
      <div class="pt-12 mb-12">
        <app-environment-table class="runbook-table" [searchTerm]="searchTerm"
          [initialDataSource]="viewResultData" [displayColumns]="viewResultColumns"
          [dataLoading]="!configResultsLoaded" [showSkeletonLoader]="true" [dataSourceLength]="true" page="releasePackView"
          pageName="releasePackView" [initialCreate]="allConfigurationStates?.length === 0 && !configResultsLoaded"
          (searchedResults)="searchedItems($event)" (configNameClick)="configurationNameClick($event)" (sorted)="resetPaginator()"
          (pageModify)="onTablePageChanged($event)" (pageChanged)="onPageChange($event)"></app-environment-table>
      </div>
    }
</div>